import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { licenseFeatures, licensePlan, SideBarNavTitle } from 'constants.js';

export default function LicenseCheck() {
  const [isLicenseLoading, setIsLicenseLoading] = useState(true);
  const [canAccessRecipientQueries, setCanAccessRecipientQueries] = useState(
    false
  );
  const [canAccessStandard, setCanAccessStandardStandard] = useState(false);
  const [canAccessSurvey, setCanAccessSurvey] = useState(false);
  const [canAccessPrint, setCanAccessPrint] = useState(false);
  const [canAccessBasic, setCanAccessBasic] = useState(false);
  const [canAccessListManagement, setCanAccessListManagement] = useState(false);
  const [canAccessBasicOrStandard, setCanAccessBasicOrStandard] = useState(
    false
  );

  const token = useSelector(store => store.user.xToken);
  const userFeatures = useSelector(store => store.user.features);
  const userLicense = useSelector(store => store.user.licensePlan);
  const isLoading = useSelector(store => store.user.licensesLoading);

  const hasFeatureBasic = () =>
    userFeatures.includes(licenseFeatures.FEATURE_ALL) ||
    userFeatures.includes(licenseFeatures.FEATURE_BASIC);

  const hasFeatureStandard = () =>
    userFeatures.includes(licenseFeatures.FEATURE_ALL) ||
    userFeatures.includes(licenseFeatures.FEATURE_STANDARD);

  const hasFeatureRecipientQueries = () =>
    userFeatures.includes(licenseFeatures.FEATURE_ALL) ||
    userFeatures.includes(licenseFeatures.FEATURE_RECIPIENT_QUERIES);

  const hasFeatureOnDemand = () =>
    userFeatures.includes(licenseFeatures.FEATURE_ALL) ||
    userFeatures.includes(licenseFeatures.FEATURE_ON_DEMAND_CAMPAIGN);

  const hasFeatureSurvey = () =>
    userFeatures.includes(licenseFeatures.FEATURE_ALL) ||
    userFeatures.includes(licenseFeatures.FEATURE_SURVEY);

  const hasFeaturePrint = () =>
    userFeatures.includes(licenseFeatures.FEATURE_PRINT);

  const hasFeatureBasicOrStandard = () =>
    hasFeatureBasic() || hasFeatureStandard();

  useEffect(() => {
    if (token) {
      setIsLicenseLoading(isLoading);
      setCanAccessRecipientQueries(hasFeatureRecipientQueries());
      setCanAccessStandardStandard(hasFeatureStandard());
      setCanAccessSurvey(hasFeatureSurvey());
      setCanAccessPrint(hasFeaturePrint());
      setCanAccessBasic(hasFeatureBasic());
      setCanAccessBasicOrStandard(hasFeatureBasicOrStandard());
      setCanAccessListManagement(hasFeatureOnDemand());
    }
  }, [isLoading, token, userFeatures, userLicense]);

  const isLicenseDisabled = title => {
    let standardTitle = [
      SideBarNavTitle.AllCampaigns,
      SideBarNavTitle.Summary,
      SideBarNavTitle.UnSubscribe,
      SideBarNavTitle.Events,
      SideBarNavTitle.Communication,
      SideBarNavTitle.Attachments,
      SideBarNavTitle.Uploads,
      SideBarNavTitle.Settings,
      SideBarNavTitle.ConditionQueries,
      SideBarNavTitle.GuestInsights,
      SideBarNavTitle.Dashboard
    ];

    let setDisabled = true;

    if (standardTitle.includes(title)) {
      setDisabled = !hasFeatureBasicOrStandard();
    } else if (title === SideBarNavTitle.RecipientQueries) {
      setDisabled = !hasFeatureRecipientQueries();
    } else if (
      title === SideBarNavTitle.Surveys ||
      title === SideBarNavTitle.SurveyResultResponseTemplates
    ) {
      setDisabled = !hasFeatureSurvey();
    } else if (title === SideBarNavTitle.ListsAndSubscribers) {
      setDisabled = !hasFeatureOnDemand();
    } else if (
      title === SideBarNavTitle.PrintTemplates ||
      title === SideBarNavTitle.Batches
    ) {
      setDisabled = !hasFeaturePrint();
    }
    return setDisabled;
  };

  return {
    isLicenseLoading,
    userFeatures,
    canAccessStandard,
    canAccessRecipientQueries,
    canAccessSurvey,
    canAccessBasic,
    canAccessBasicOrStandard,
    canAccessListManagement,
    canAccessPrint,
    hasFeatureSurvey,
    hasFeatureOnDemand,
    hasFeatureStandard,
    isLicenseDisabled,
    hasFeaturePrint
  };
}
